import _JSXStyle from "styled-jsx/style";
import PropTypes from 'prop-types';
import React from 'react';
export const TagIcon = _ref => {
  let {
    children,
    dataTest
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    "data-test": dataTest,
    className: "jsx-1638813748"
  }, children, /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "1638813748"
  }, [".jsx-1638813748{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-inline-end:4px;max-height:16px;max-width:16px;}"]));
};
TagIcon.propTypes = {
  dataTest: PropTypes.string.isRequired,
  children: PropTypes.node
};